<h2 mat-dialog-title>Export payments report (Excel)</h2>

<mat-dialog-content>
  <p class="hint">
    Every payment on the chosen day: who was paid, the amount, status, description,
    the coins it bought, and the payment proofs.
  </p>

  <mat-form-field appearance="outline" class="date">
    <mat-label>Day</mat-label>
    <input matInput type="date" [(ngModel)]="date" [attr.max]="max">
    <mat-hint>Timezone: {{ tz }}</mat-hint>
  </mat-form-field>

  <mat-button-toggle-group class="date-by" [(ngModel)]="dateBy" aria-label="Which day">
    <mat-button-toggle value="">Recorded or paid</mat-button-toggle>
    <mat-button-toggle value="created">Recorded on</mat-button-toggle>
    <mat-button-toggle value="paid">Paid on</mat-button-toggle>
  </mat-button-toggle-group>
  <p class="date-by-hint">
    @switch (dateBy) {
    @case ('created') { Settlements recorded on this day, paid or not. }
    @case ('paid') { Settlements paid on this day — the same days the Hesabfa export counts. }
    @default { Settlements recorded or paid on this day; one recorded and paid on different days is in both. }
    }
  </p>

  <mat-checkbox [(ngModel)]="includeProofs">Include payment proof images (larger file)</mat-checkbox>

  @if (data.supplierId || data.status) {
  <p class="filters">
    Filtered to
    @if (data.supplierId) { supplier <b>{{ data.supplierLabel || 'selected' }}</b> }
    @if (data.status) { status <b>{{ data.status }}</b> }
    — clear the filters on the page first for everything.
  </p>
  }
  @if (error) { <p class="error">{{ error }}</p> }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" (click)="dialogRef.close(false)">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!date || downloading" (click)="download()">
    @if (downloading) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>download</mat-icon> }
    Download .xlsx
  </button>
</mat-dialog-actions>
